module.exports = __webpack_public_path__ + "static/media/background.e3b5f145.jpg";